export default __webpack_public_path__ + "static/media/os8.489384d6.png";